/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_FeaturesInputs */

const zh_landing_footer_features = /** @type {(inputs: Landing_Footer_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能`)
};

const en_landing_footer_features = /** @type {(inputs: Landing_Footer_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const es_landing_footer_features = /** @type {(inputs: Landing_Footer_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Landing_Footer_FeaturesInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_footer_features = /** @type {((inputs?: Landing_Footer_FeaturesInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_FeaturesInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_footer_features(inputs)
	if (locale === "en") return en_landing_footer_features(inputs)
	return es_landing_footer_features(inputs)
});